/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Unit_Keyword_PluralInputs */

const en_measure_unit_keyword_plural = /** @type {(inputs: Measure_Unit_Keyword_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`keywords`)
};

const zh_hans1_measure_unit_keyword_plural = /** @type {(inputs: Measure_Unit_Keyword_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关键词`)
};

const pt_br2_measure_unit_keyword_plural = /** @type {(inputs: Measure_Unit_Keyword_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`palavras-chave`)
};

const es_measure_unit_keyword_plural = /** @type {(inputs: Measure_Unit_Keyword_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`palabras clave`)
};

const fr_measure_unit_keyword_plural = /** @type {(inputs: Measure_Unit_Keyword_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mots-clés`)
};

const de_measure_unit_keyword_plural = /** @type {(inputs: Measure_Unit_Keyword_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keywords`)
};

const ru_measure_unit_keyword_plural = /** @type {(inputs: Measure_Unit_Keyword_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ключевых слов`)
};

const it_measure_unit_keyword_plural = /** @type {(inputs: Measure_Unit_Keyword_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`parole chiave`)
};

/**
* | output |
* | --- |
* | "keywords" |
*
* @param {Measure_Unit_Keyword_PluralInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_keyword_plural = /** @type {((inputs?: Measure_Unit_Keyword_PluralInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Keyword_PluralInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_keyword_plural(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_keyword_plural(inputs)
	if (locale === "es") return es_measure_unit_keyword_plural(inputs)
	if (locale === "fr") return fr_measure_unit_keyword_plural(inputs)
	if (locale === "de") return de_measure_unit_keyword_plural(inputs)
	if (locale === "ru") return ru_measure_unit_keyword_plural(inputs)
	if (locale === "it") return it_measure_unit_keyword_plural(inputs)
	return en_measure_unit_keyword_plural(inputs)
});